<div *ngFor="let filterGroup of filterGroups"
    class="group">
    <div *ngIf="filterGroup.visible"
        class="group-name">{{ filterGroup.name }}</div>
    <app-catalog-filter [stacked]="true"
        [items]="filterGroup.filterItems"
        (emitItemSelect)="selectTag($event)"></app-catalog-filter>
</div>